import MainLayout from "../components/SharedComponents/MainLayout";
import HeroSection from "../components/LandingPageComponents/HeroSection";
import FeaturesSection from "../components/LandingPageComponents/FeaturesSection";
import CategoriesSection from "../components/LandingPageComponents/CategoriesSection";
import NewsLetterSection from "../components/LandingPageComponents/NewsLetterSection";

export default function LandingPage(){
    return(<div>
        <MainLayout>
            <HeroSection/>
            <FeaturesSection/>
            <CategoriesSection/>
            <NewsLetterSection />
        </MainLayout>
    </div>)
    
}